import { render, staticRenderFns } from "./AttributeTableWin.vue?vue&type=template&id=5d9f9a7b&scoped=true&"
import script from "./AttributeTableWin.vue?vue&type=script&lang=js&"
export * from "./AttributeTableWin.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTableWin.vue?vue&type=style&index=0&id=5d9f9a7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f9a7b",
  null
  
)

export default component.exports